import { render, staticRenderFns } from "./golongankredit.vue?vue&type=template&id=54195091&scoped=true"
import script from "./golongankredit.vue?vue&type=script&lang=js"
export * from "./golongankredit.vue?vue&type=script&lang=js"
import style0 from "./golongankredit.vue?vue&type=style&index=0&id=54195091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54195091",
  null
  
)

export default component.exports